import AppConstants from '../config/app.constants';

let SetupService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/setup`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/setup/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/setup/${id}`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/setup/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/setup/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let supervisorList = (branchId) => {
        return $http
            .get(AppConstants.api + `/setup/supervisor-list`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getAutoGeneratedTrackingId = (branchId, cursor) => {
        return $http
            .get(AppConstants.api + `/setup/get-auto-generated-tracking-id`, {
                params: {
                    branchId, cursor
                }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get,
        supervisorList,
        getAutoGeneratedTrackingId
    };
};

SetupService.$inject = ['$http', '$q']

export default SetupService;


// WEBPACK FOOTER //
// ./client/app/services/setup.service.js